<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :total-items="totalItems"
    :label="label || 'Категорія продукта'"
    placeholder="Введіть категорію продукта"
    :items.sync="items"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    component-name="ProductCategory"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as productCategoriesApi from "@/backend/productCategoriesApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Категорія продукта",
    },
    value: {
      type: Object,
    },
    errorMessages: {
      type: Array,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const {
        result,
        totalItems,
      } = await productCategoriesApi.selectProductCategory(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
